const ferries = {
  ferry: "Keltas", // translated 
  ferries: "Keltai", // translated 
  selectOriginPort: "Pasirinkite pradinį prievadą", // translated 
  selectDestPort: "Pasirinkite paskirties prievadą", // translated 
  continue: "Tęsti", // translated 
  viewTimetables: "Žiūrėti tvarkaraščius", // translated 
  operator: "operatorius", // translated 
  cabin: "Kabina", // translated 
  cabins: "Kajutės", // translated 
  place: "Vieta", // translated 
  places: "Vietos", // translated 
  seat: "Sėdynės", // translated 
  seats: "Sėdynės", // translated 
  seating: "Sėdimosios vietos", // translated 
  deckSpace: "Denio erdvė", // translated 
  compulsory: "privalomas", // translated 
  departure: "Išvykimas", // translated 
  total: "Iš viso", // translated 
  back: "Atgal", // translated 
  next: "Kitas", // translated 
  duration: "Trukmė", // translated 
  return: "Grįžti", // translated 
  prebook: "Išankstinė knyga", // translated 
  travelInfo: "Informacija apie keliones", // translated 
  book: "Knyga", // translated 
  adults: "Suaugusieji", // translated 
  child: "Vaikas", // translated 
  seniors: "Senjorai", // translated 
  senior: "Vyresnysis", // translated 
  to: "į", // translated 
  passenger: "Keleivis", // translated 
  details: "Detalės", // translated 
  currencyForTickets: "Šių bilietų valiuta bus", // translated 
  seatsError: "Keleivių skaičius nėra lygus talpai.", // translated 
  title: "Pavadinimas", // translated 
  firstName: "Pirmas vardas", // translated 
  lastName: "Pavardė", // translated 
  email: "El. paštas", // translated 
  phone: "Telefonas", // translated 
  dateOfBirth: "Gimimo data", // translated 
  placeOfBirth: "Gimimo vieta", // translated 
  groupLeader: "Grupės lyderis", // translated 
  isRequired: "Reikalingas", // translated 
  charactersOnly: "Tik simboliai", // translated 
  latinCharactersAndSpacesOnly: "Tik lotyniški simboliai ir tarpai", // translated 
  validEmail: "Netinkamas el. paštas", // translated 
  atLeastOneAdult: "Reikalingas bent 1 suaugęs asmuo.", // translated 
  atLeastOneSenior: "Reikalingas bent 1 senjoras.", // translated 
  toastAlert: "Ištaisykite visas klaidas toliau pateiktose formose.", // translated 
  backToFerriesList: "Grįžti į keltų sąrašą", // translated 
  bestPrice: "Geriausia kaina", // translated 
  fastest: "Greičiausias", // translated 
  beforeDeparture: "Prieš išvykstant", // translated 
  perPerson: "vienam asmeniui", // translated 
  notAvailableForOnlineBooking: "Negalima užsisakyti internetu", // translated 
  hurryLimitedAvailability: "Paskubėk! Ribotas prieinamumas", // translated 
  berth: "Prieplauka", // translated 
  berths: "Krantinės", // translated 
  sumOfSelectionNotEqualToPersons:
    "Jūsų pasirinkimo suma nėra lygi keleivių skaičiui", // translated 
  attemptToBook: "Iš viso bandėte užsisakyti", // translated 
  seatsWhenYouHave: "vietų, kai turite", // translated 
  passengersTravelling: "keliaujančių keleivių", // translated 
  withReturn: "su bilietais atgal", // translated 
  pleaseCorrectYourSelection: "Pataisykite pasirinkimą", // translated 
  pleaseSelectUpTo: "Pasirinkite iki", // translated 
  accommodationTypes: "apgyvendinimo tipai", // translated 
  selectionPrices: "Pasirinkimo kainos", // translated 
  yourCurrentTicket: "Jūsų dabartinis bilieto tipas yra", // translated 
  upgradeTo: "Atnaujinkite į", // translated 
  wouldYouLikeToUpgrade: "Ar norėtumėte atnaujinti savo bilieto tipą?", // translated 
  backToTicketTypes: "Grįžti į bilietų tipus", // translated 
  originPort: "Kilmės uostas", // translated 
  destinationPort: "Kelionės tikslo uostas", // translated 
  outboundDate: "Išvykimo data", // translated 
  inboundDate: "Atvykimo data", // translated 
  passengers: "Keleiviai", // translated 
  hasReturn: "Turi Grąžinimą", // translated 
  passportNumber: "Paso numeris", // translated 
  passportExpiryDate: "paso galiojimo data", // translated 
  passportPlaceOfIssue: "Paso išdavimo vieta", // translated 
  passportStartDate: "Paso pradžios data", // translated 
  cityCode: "Miesto kodas", // translated 
};



export default ferries;
